<div class="modal-body">
	<div class="calculator-container">
		<div class="calculator-header">
			<h5>Calculator</h5>
			<button
				type="button"
				class="btn-close close-btn"
				data-bs-dismiss="modal"
				aria-label="Close"
				(click)="close()"
			></button>
		</div>

		<input class="calculator-display" [value]="display" readonly type="text" />

		<div class="calculator-grid">
			<!-- Ligne 1 -->
			<button class="btn-action orange" (click)="clear()">C</button>
			<button class="btn-op gray" (click)="press('/')">÷</button>
			<button class="btn-op gray" (click)="press('%')">%</button>
			<button class="btn-action orange" (click)="backspace()">⌫</button>

			<!-- Ligne 2 -->
			<button class="btn-num white" (click)="press('7')">7</button>
			<button class="btn-num white" (click)="press('8')">8</button>
			<button class="btn-num white" (click)="press('9')">9</button>
			<button class="btn-op gray" (click)="press('*')">×</button>

			<!-- Ligne 3 -->
			<button class="btn-num white" (click)="press('4')">4</button>
			<button class="btn-num white" (click)="press('5')">5</button>
			<button class="btn-num white" (click)="press('6')">6</button>
			<button class="btn-op gray" (click)="press('-')">−</button>

			<!-- Ligne 4 -->
			<button class="btn-num white" (click)="press('1')">1</button>
			<button class="btn-num white" (click)="press('2')">2</button>
			<button class="btn-num white" (click)="press('3')">3</button>
			<button class="btn-op gray" (click)="press('+')">+</button>

			<!-- Ligne 5 -->
			<button class="btn-num white" (click)="press('0')">0</button>
			<button class="btn-num white" (click)="press('00')">00</button>
			<button class="btn-num white" (click)="press('.')">.</button>
			<button class="btn-action orange" (click)="calculate()">=</button>
		</div>
	</div>
</div>
